<div class="container-fluid bg-surface h-content px-0">
  <div *ngIf="assistType === 'medical'">
    <div class="bg-white py-4">
      <nav class="container px-4">
        <ol class="breadcrumb tas-breadcrumb mb-0 f-13 f-lg-16">
          <a [routerLink]="['/refund']" [queryParams]="{ action: 'history' }"
            ><img
              src="https://res.cloudinary.com/pervolare-org/image/upload/v1760599525/TAS/rutt/requirements/home_ecyogr.svg"
              alt="icon home"
          /></a>
          <img
            class="mx-2"
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1760599508/TAS/rutt/requirements/arrow_bju9xz.svg"
            alt="icon"
          />
          <li class="breadcrumb-item">
            <a class="text-decoration-none">Tipo de reembolso</a>
          </li>
          <img
            class="mx-2"
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1760599508/TAS/rutt/requirements/arrow_bju9xz.svg"
            alt="icon"
          />
          <li class="breadcrumb-item active fw-bold" aria-current="page">
            Requisitos de reembolso
          </li>
        </ol>
      </nav>
    </div>

    <div class="px-2">
      <div class="container">
        <div class="text-center mb-5 mt-4">
          <h1 class="text-primary fw-medium f-24 f-lg-32">
            Antes de iniciar tu solicitud:
          </h1>
        </div>

        <div class="row g-4 justify-content-center">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-3">
            <div class="h-100 p-4 requirement-card">
              <div class="text-center mb-3">
                <img
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1760598730/TAS/rutt/requirements/aceptas-tratamiento_wfikzp.png"
                  alt="icon tratamiento de datos"
                />
              </div>
              <p class="mb-0 f-16">
                <span class="fw-bold">1. Al continuar,</span> aceptas el
                tratamiento de tus datos personales conforme a nuestra política
                de privacidad.
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-6 col-xl-3">
            <div class="h-100 p-4 requirement-card">
              <div class="text-center mb-3">
                <img
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1760598818/TAS/rutt/requirements/facturas-listas_pm3uq6.png"
                  alt="icon facturas listas"
                />
              </div>
              <p class="mb-0 f-16">
                <span class="fw-bold">2. Ten todas las facturas listas,</span>
                ya que no podrás modificar el formulario después de enviarlo.
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-6 col-xl-3">
            <div class="h-100 p-4 requirement-card">
              <div class="text-center mb-3">
                <img
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1760598948/TAS/rutt/requirements/ICON_Pasaporte_hckkur.png"
                  alt="icon recetas medicas"
                />
              </div>
              <p class="mb-0 f-16">
                <span class="fw-bold">3. Adjunta recetas,</span>
                informes o reportes médicos, autorizaciones de exámenes y/o
                procedimientos según corresponda.
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-6 col-xl-3">
            <div class="h-100 p-4 requirement-card">
              <div class="text-center mb-3">
                <img
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1760598948/TAS/rutt/requirements/ICON_Pasaporte_hckkur.png"
                  alt="icon pasaporte"
                />
              </div>
              <p class="mb-0 f-16">
                <span class="fw-bold">4. Toma una foto de tu pasaporte,</span>
                asegurándote de que se vean los datos personales y los sellos de
                entrada y salida.
              </p>
            </div>
          </div>
        </div>

        <div class="text-center mt-5 mb-5 pb-5">
          <button class="btn btn-action f-16 px-5" (click)="goNext()">
            Continuar reembolso
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="assistType === 'travel'">
    <div class="bg-white py-4">
      <nav class="container px-4">
        <ol class="breadcrumb tas-breadcrumb mb-0 f-13 f-lg-16">
          <a [routerLink]="['/refund']" [queryParams]="{ action: 'history' }"
            ><img
              src="https://res.cloudinary.com/pervolare-org/image/upload/v1760599525/TAS/rutt/requirements/home_ecyogr.svg"
              alt="icon home"
          /></a>

          <img
            class="mx-2"
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1760599508/TAS/rutt/requirements/arrow_bju9xz.svg"
            alt="icon"
          />

          <li class="breadcrumb-item">
            <a class="text-decoration-none">Tipo de reembolso</a>
          </li>

          <img
            class="mx-2"
            src="https://res.cloudinary.com/pervolare-org/image/upload/v1760599508/TAS/rutt/requirements/arrow_bju9xz.svg"
            alt="icon"
          />

          <li class="breadcrumb-item active fw-bold" aria-current="page">
            Requisitos de reembolso
          </li>
        </ol>
      </nav>
    </div>

    <div class="px-2">
      <div class="container">
        <div class="text-center mb-5 mt-4">
          <h1 class="text-primary fw-medium f-24 f-lg-32">
            Antes de iniciar tu solicitud:
          </h1>
        </div>

        <div class="row g-4 justify-content-center">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-3">
            <div class="h-100 p-4 requirement-card">
              <div class="text-center mb-3">
                <img
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1760598730/TAS/rutt/requirements/aceptas-tratamiento_wfikzp.png"
                  alt="icon tratamiento de datos"
                />
              </div>

              <p class="mb-0 f-16">
                <span class="fw-bold">1. Al continuar,</span> aceptas el
                tratamiento de tus datos personales conforme a nuestra política
                de privacidad.
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-6 col-xl-3">
            <div class="h-100 p-4 requirement-card">
              <div class="text-center mb-3">
                <img
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1760598818/TAS/rutt/requirements/facturas-listas_pm3uq6.png"
                  alt="icon facturas listas"
                />
              </div>

              <p class="mb-0 f-16">
                <span class="fw-bold">2. Ten todas las facturas listas,</span>

                ya que no podrás modificar el formulario después de enviarlo.
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-6 col-xl-3">
            <div class="h-100 p-4 requirement-card">
              <div class="text-center mb-3">
                <img
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1760598948/TAS/rutt/requirements/ICON_Pasaporte_hckkur.png"
                  alt="icon recetas medicas"
                />
              </div>

              <p class="mb-0 f-16">
                <span class="fw-bold">3. Carta de la aerolínea,</span> PIR o
                reclamo y las facturas de los gastos autorizados. Si es por
                pasaporte, envía la denuncia de pérdida o robo.
              </p>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-lg-6 col-xl-3">
            <div class="h-100 p-4 requirement-card">
              <div class="text-center mb-3">
                <img
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1760598948/TAS/rutt/requirements/ICON_Pasaporte_hckkur.png"
                  alt="icon pasaporte"
                />
              </div>

              <p class="mb-0 f-16">
                <span class="fw-bold">4. Toma una foto de tu pasaporte,</span>

                asegurándote de que se vean los datos personales y los sellos de
                entrada y salida.
              </p>
            </div>
          </div>
        </div>

        <div class="text-center mt-5 mb-5 pb-5">
          <button class="btn btn-action f-16 px-5" (click)="goNext()">
            Continuar reembolso
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
